<template>
<div class="chapter">
<div class="inner_page">
<h1>Tabla de Contenido</h1>
<p><span href="#/c001" title="Link target outside of Sample">Título</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Derechos de Autor</span></p>
<p><a href="#/c003">OBRAS MAESTRAS DE MALICIA 6</a></p>
<p><a href="#/c004">NOTA DEL EDITOR | Esta es una obra de ficción. Los nombres, personajes, lugares, e incidentes son el producto de la imaginación del autor o se utilizan ficticiamente, y cualquier parecido con personas reales, vivas o muertas, establecimientos empresariales, eventos, o locales es totalmente coincidente. | El editor no tiene ningún control ni asume ninguna responsabilidad por el autor o por sitios web de terceros o su contenido.</a></p>
<p><a href="#/c005">MALICIA METÓDICA | LIBRO 26</a></p>
<p><span href="#/c006" title="Link target outside of Sample">MALICIA MALÉVOLA | LIBRO 27</span></p>
<p><span href="#/c007" title="Link target outside of Sample">MALICIA MILITAR | LIBRO 28</span></p>
<p><span href="#/c008" title="Link target outside of Sample">MALICIA MAQUIAVÉLICA | LIBRO 29</span></p>
<p><span href="#/c009" title="Link target outside of Sample">MALICIA MALÉFICA | LIBRO 30</span></p>
<p><span href="#/c010" title="Link target outside of Sample">-Fin-</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?9c30fa64